import { Grid, Heading, Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

export function KnowledgeDatabaseHeader() {
  const { t } = useTranslation("ui");
  return (
    <Grid gap="2" data-testid="knowledge-database-header">
      <Heading
        size="8"
        className="font-sans"
        data-testid="knowledge-database-title"
      >
        {t("settings.knowledgeDatabaseHeader.knowledgeDatabase")}
      </Heading>
      <Text size="3" color="gray" data-testid="knowledge-database-description">
        {t("settings.knowledgeDatabaseHeader.manageInformationUsedByPuntt")}
      </Text>
    </Grid>
  );
}
